import { API_BASE_URL } from "../../constants/index"; // Base URL for the API
import HttpInterface from "../../helpers/HttpInterface"; // Helper class for making HTTP requests
import { defaultFetchParam, FetchParam } from "../../Models/FetchParam"; // Fetch parameters model and default values
import { StoreIntegration } from "../../Models/StoreIntegration"; // Store integration model
import { PaginatedResponse } from "../../Models/Pagination"; // Pagination model to handle paginated responses
import { buildAPIUrl } from "../../utilities/api"; // Utility function to build the API URL with query parameters

export class StoreIntegrationsService {
  private httpProxy: HttpInterface; // Instance of the HttpInterface to make HTTP requests

  // Constructor initializes the httpProxy with the HttpInterface
  constructor() {
    this.httpProxy = new HttpInterface(); // Creates an instance of the HttpInterface to handle requests
  }

  /**
   * Fetches all store integrations from the store service API.
   *
   * @param params The query parameters for the API request. Defaults to `defaultFetchParam` if not provided.
   * @returns A promise that resolves with the API response containing the paginated list of store integrations.
   */
  all(
    params: FetchParam = defaultFetchParam
  ): Promise<{ data: PaginatedResponse<StoreIntegration> }> {
    const requestOptions = {
      method: "GET", // HTTP method for the request
    };

    // Builds the complete API URL using the base URL, endpoint, and parameters
    return this.httpProxy.fetch(
      buildAPIUrl(
        `${API_BASE_URL}/logistic-service/store-integrations`,
        params
      ),
      requestOptions
    );
  }

  /**
   * Fetches a single store integration by its ID from the API.
   *
   * @param id The unique identifier of the store integration to fetch.
   * @returns A promise that resolves with the API response containing the store integration details.
   */
  get(id: string): Promise<StoreIntegration> {
    const requestOptions = {
      method: "GET", // HTTP method for the request
    };

    // Constructs the URL for fetching a specific store integration by its ID
    return this.httpProxy.fetch(
      `${API_BASE_URL}/logistic-service/store-integrations/${id}`,
      requestOptions
    );
  }
}
